import { ApiError, type Page } from '@vlm/api';
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // a 4xx will not change on a retry; a network blip or a 5xx might
      retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
    },
    mutations: { retry: false },
  },
});

/** Every page of a list, for pickers (the API caps a page at 1000). */
export async function fetchAllPages<T>(load: (page: number, size: number) => Promise<Page<T>>, size = 1000): Promise<T[]> {
  const first = await load(0, size);
  if (first.totalPages <= 1) return first.content;
  const rest = await Promise.all(Array.from({ length: first.totalPages - 1 }, (_, i) => load(i + 1, size)));
  return [first.content, ...rest.map((p) => p.content)].flat();
}
